package fr.frux.shared.dto

import kotlinx.serialization.Serializable

/**
 * Nature d'un lieu rendu par la recherche de lieux (#394). Le client en dérive le zoom cible :
 * une commune se regarde de loin, une adresse de près.
 */
@Serializable
enum class PlaceKind { MUNICIPALITY, STREET, ADDRESS, LOCALITY, POI }

/**
 * Un lieu géocodé. [label] est le nom court (« Fontenay-Trésigny »), [detail] le complément
 * affichable (« 77610 », « 75002 Paris », « plan d'eau, Lyon ») ou `null` s'il n'apporte rien.
 */
@Serializable
data class PlaceDto(
    val label: String,
    val detail: String? = null,
    val kind: PlaceKind,
    val latitude: Double,
    val longitude: Double,
)

/** Réponse de `GET /api/v1/places/search` : au plus cinq lieux, liste vide admise. */
@Serializable
data class PlaceSearchResponse(
    val places: List<PlaceDto>,
)
